export const tagColor: Record<string, string> = {
  'Commercial': 'bg-[#E3FFFB]',
  'Family': 'bg-[#ABEAFF]',
  'Corporate': 'bg-[#D2F6FF]',
  'Partnership': 'bg-[#FFEBB7]',
  'Insolvency': 'bg-[#FEE4E1]',
  'Data Protection': 'bg-[#C5E1A5]',
  'Privacy': 'bg-[#F3E5F5]',
  'Intellectual Property': 'bg-[#FFF4C1]',
  'Consumer': 'bg-[#FFD3E0]',
  'Telecommunications': 'bg-[#B3E5FC]',
  'Estate Administration': 'bg-[#FAFAFA]',
  'Employment': 'bg-[#FFF3E0]',
  'Equality': 'bg-[#9DCCFA]',
  'Property': 'bg-[#B2DFDB]',
}
